var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M22.69 10.907c7.4 0 13.816 7.713 14.235 12.99.578 7.284-5.024 13.397-12.56 12.99-6.5-.35-13.393-7.374-13.1-9.596.408-3.256 3.141-1.175 4.188-3.347 1.048-2.173-4.35-2.998-2.812-8.166 1.753-4.121 5.97-4.871 10.049-4.871zm3.276 19a2 2 0 100 4 2 2 0 000-4zm-9.452-2.063c-.666.767-.308 1.72.525 2.445.834.724 1.831.942 2.494.18.662-.762.308-1.72-.526-2.445-.833-.724-1.827-.946-2.493-.18zm14.952-5.937c-1.933 0-3.5 1.343-3.5 3s1.567 3 3.5 3 3.5-1.343 3.5-3-1.567-3-3.5-3zm-7-7a3.5 3.5 0 100 7 3.5 3.5 0 000-7z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
